import { Routes } from '@angular/router';
import { CmsPageComponent, cmsPageTemplateResolver } from '@domgen/dgx-fe-cms';
import { ErrorGaCategory } from '@error/util-models';

export const ERROR_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      gaData: {
        eventCategory: ErrorGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
    },
  },
];
